import { VStack } from '@ayble-health/dashboard-components';
import { UserBlock } from '../../../models/block';
import { Box } from '@chakra-ui/react';
import BlockFeedback from 'components/UserDashboard/overview/BlockFeedback';
import BlockFeedbackForm from 'components/UserDashboard/overview/BlockFeedbackForm';
import BlockOverview from 'components/UserDashboard/overview/BlockOverview';

type Props = {
  block: UserBlock;
};

export const BlockEditContent = ({ block }: Props) => {
  return (
    <VStack flex={1} overflow={'auto'}>
      <VStack flex={1} py={2} px={3} gap={3} overflowY={'auto'}>
        <BlockOverview block={block} />
        <BlockFeedback block={block} />
      </VStack>
      <Box>
        <BlockFeedbackForm blockId={block.id} />
      </Box>
    </VStack>
  );
};
